import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const AudioOffIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M4.74872 7.16302L2.70711 5.12141C2.31658 4.73089 2.31658 4.09772 2.70711 3.7072C3.09763 3.31668 3.7308 3.31668 4.12132 3.7072L20.1381 19.724C20.5287 20.1145 20.5287 20.7477 20.1381 21.1382C19.7476 21.5288 19.1145 21.5288 18.7239 21.1382L16 18.4143V20.6732C16 21.7522 14.7026 22.3785 13.7718 21.7487L6.47924 16.8148H3.40704C2.62995 16.8148 2 16.2218 2 15.4903V8.48753C2 7.75602 2.62995 7.16302 3.40704 7.16302H4.74872ZM7.09225 14.8148L14 19.4883V16.4143L6.74872 9.16302H4V14.8148H7.09225Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M14 4.50391L9.75394 7.33982L8.31196 5.89784L13.7788 2.2466C14.7105 1.62432 16 2.25143 16 3.32683V13.5859L14 11.5859V4.50391Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
